module.exports = __webpack_public_path__ + "img/service03.b64d7608.svg";